import { useState } from 'react'
import { PageHeader } from '@/widgets/layout/ui/AppLayout'
import { Button } from '@/shared/ui'
import { useAdminAudit } from '@/entities/admin'
import { AdminAuditList } from '../shared/AdminAuditList'
import { AdminPagination, AdminRemoteState } from '../shared/AdminRemoteState'
import { formatNumber } from '../shared/format'
import styles from '../AdminPages.module.css'

const LIMIT = 50

export function AdminAuditPage() {
  const [companyId, setCompanyId] = useState('')
  const [offset, setOffset] = useState(0)
  const parsedCompanyId = companyId ? Number(companyId) : undefined
  const audit = useAdminAudit({
    companyId:
      parsedCompanyId && Number.isInteger(parsedCompanyId) && parsedCompanyId > 0
        ? parsedCompanyId
        : undefined,
    limit: LIMIT,
    offset,
  })

  return (
    <>
      <PageHeader
        title="Журнал"
        description="Действия суперадминистраторов с компаниями и пользователями."
      />

      <div className={styles.toolbar}>
        <label className={styles.field}>
          <span className={styles.label}>ID компании</span>
          <input
            className={styles.input}
            type="number"
            min="1"
            inputMode="numeric"
            value={companyId}
            onChange={(event) => {
              setCompanyId(event.target.value)
              setOffset(0)
            }}
            placeholder="Все компании"
          />
        </label>
        {companyId && (
          <Button
            variant="ghost"
            onClick={() => {
              setCompanyId('')
              setOffset(0)
            }}
          >
            Сбросить
          </Button>
        )}
        <span className={styles.count}>Записей: {formatNumber(audit.data?.total ?? 0)}</span>
      </div>

      {audit.isPending ? (
        <AdminRemoteState kind="loading" />
      ) : audit.isError ? (
        <AdminRemoteState
          kind="error"
          message="Журнал действий не загрузился."
          onRetry={() => void audit.refetch()}
        />
      ) : !audit.data?.items.length ? (
        <AdminRemoteState
          kind="empty"
          title="В журнале пока нет записей"
          message="Административные действия появятся здесь после первого изменения."
        />
      ) : (
        <>
          <AdminAuditList items={audit.data.items} />
          <AdminPagination
            total={audit.data.total}
            offset={offset}
            limit={LIMIT}
            onChange={setOffset}
            disabled={audit.isFetching}
          />
        </>
      )}
    </>
  )
}
